import { Week_Grid_List } from '@app/post-lists/week-grid-list'
import { Ctx } from '@app/context'
import { List_Manage_Assembly_Presenter } from '@app/controllers/assembly-controller'
import { DateTime } from 'luxon'
import { GT_Project } from '../../types/projects'
import { Grid_Result, Grid_Results, Mapped_Results } from '@app/post-lists/grid-list'
import { List_Manage_Status_Workers_Presenter } from '@app/controllers/workers-controller'

export class Assembly_List extends Week_Grid_List {
    assembly_presenter: List_Manage_Assembly_Presenter
    status_workers_presenter: List_Manage_Status_Workers_Presenter

    constructor( ctx: Ctx ) {
        super( ctx )

        this.set_projects( ctx.projects )
        this.set_dates( ctx.dates )
        this.set_remaining_work( ctx.remaining_work )

        this.init_columns()

        this.assembly_presenter = new List_Manage_Assembly_Presenter( this )
        this.status_workers_presenter = new List_Manage_Status_Workers_Presenter( this )

        this.render_results()
    }

    ready() {
        super.ready()
        this.assembly_presenter.ready()
        this.status_workers_presenter.ready()
    }
    protected map_results(): Mapped_Results {
        const mapped_results: Map<string, Grid_Results> = new Map()

        for ( const column of this.columns.keys() ) {
            mapped_results.set( column, [] )
        }

        // alle Projekte mappen
        for ( const project of gt_results.projects ) {
            console.log( 'mapping', project )
            const date = project.assembly?.date

            if ( ! date ) {
                continue
            }

            const dt: DateTime = DateTime.fromSQL( date )

            if ( ! this.in_current_week( dt ) ) {
                continue
            }

            if ( project.assembly?.type === 'week' ) {
                this.populate_column( mapped_results, 'week', project )
                continue
            }

            const key = this.get_weekday_key( dt )
            this.populate_column( mapped_results, key, project )
        }

        // alle Restarbeiten mappen
        for ( const assembly of gt_results.dates ) {
            console.log( 'additional assembly', assembly )
            const project: GT_Project|undefined = gt_results.projects.find( ( el: GT_Project ): boolean => el.post_id === assembly.project_post_id )

            if ( ! project ) {
                continue
            }

            const dt: DateTime = DateTime.fromSQL( assembly.dates.start.date )

            if ( ! this.in_current_week( dt ) ) {
                continue
            }

            const key = this.get_weekday_key( dt )
            this.populate_column( mapped_results, key, project )
        }

        console.log( 'list columns', this.columns )
        console.log( 'filtered projects', mapped_results )

        return mapped_results
    }

    protected get_weekday_key( dt: DateTime ) {
        const weekday = dt.weekday
        const keys: string[] = [ 'mon', 'tue', 'wed', 'thu', 'fri' ]

        return keys[weekday - 1]
    }

    protected populate_column( mapped_results: Map<string, Grid_Results>, key: string, result: Grid_Result ) {
        ( mapped_results.get( key ) as Grid_Results ).push( result )
    }

    protected in_current_week( dt: DateTime ): boolean {
        return dt.weekNumber === this.week_filter.get_current_week().week && dt.weekYear === this.week_filter.get_current_week().year
    }

    protected render_project( key: string, result: GT_Project ) {
        console.log( 'render', result.post_type, result, key )

        const column = this.columns.get( key ) as HTMLElement
        const container: HTMLElement|null = column.querySelector( '.column-projects' )

        if ( ! container ) {
            return
        }

        const post: HTMLDivElement = document.createElement( 'div' )
        post.dataset.postId = result.post_id.toString()
        post.classList.add( 'column-item', 'project-item' )

        post.appendChild( this.create_project_schedule_title( post, result ) )
        post.appendChild( this.create_project_detailed_status( post, result ) )
        post.appendChild( this.create_project_assembly_dates( post, result ) )
        post.appendChild( this.create_project_storage_yard( post, result ) )
        post.appendChild( this.create_project_status_workers( post, result ) )
        post.appendChild( this.create_project_remaining_work( post, result ) )

        container.append( post )
    }

    protected create_project_detailed_status( _post: HTMLDivElement, project: GT_Project ): HTMLDivElement {
        const div = document.createElement( 'div' )

        div.classList.add( 'project-detailed-status' )
        div.dataset.projectStatus = project.status?.slug

        div.innerHTML = `<div><span class="badge status">${project.status?.name}</span></div>`

        if ( project.substatus ) {
            div.innerHTML += `<div><span class="badge status secondary">${project.substatus?.name}</span></div>`
        }

        return div
    }

    protected create_project_storage_yard( _post: HTMLDivElement, project: GT_Project ): HTMLDivElement {
        const div: HTMLDivElement = document.createElement( 'div' )
        const storage_yards = project.storage_yards
        div.classList.add( 'project-storage-yard' )

        if ( ! storage_yards || ! ( 'assembly' in storage_yards ) || ! storage_yards.assembly.length ) {
            return div
        }

        div.innerHTML = `<span class="badge"><i class="dolly flatbed icon"></i>${storage_yards.assembly}</span>`

        return div
    }

    public ajax_load_week_posts( day: DateTime|null = null ) {
        this.week_filter.disable_week_interactions()

        const monday: DateTime = day ? day : this.week_filter.get_current_monday()

        if ( ! monday.isValid ) {
            return false
        }

        const { ajax_url, nonce } = gt_ajax_object

        const action = 'load_assembly_projects'

        const data = {
            action,
            start: monday.toFormat( 'yyyy-MM-dd' ),
            end: monday.plus( { weeks: 1 } ).toFormat( 'yyyy-MM-dd' ),
            week: monday.toFormat( 'WW/kkkk' ),
            status: 'assembly',
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                this.set_projects( response.projects )
                this.set_dates( response.dates ?? [] )

                this.render_results()

                this.week_filter.enable_week_interactions()
            }
        )
    }

    public reload_results(): void {
        const monday = this.week_filter.get_current_monday()
        this.ajax_load_week_posts( monday )
    }
}
